module.exports = __webpack_public_path__ + "static/media/supplies_landing.a671a873.jpg";